<template>
  <div class="reportTemplateWrap mainPageBg"
    v-loading="$store.state.user.loadingState">
    <div class="leftMenu">
      <div style="margin-top: 30px; text-align: center">
        <el-input style="width: 90%;"
          placeholder="请输入模板名称"
          v-model="searchTxt"
          class="input-with-select">
          <el-button slot="append"
            icon="el-icon-search"
            @click="getMenuList"></el-button>
        </el-input>
      </div>
      <div class="listUl"
        v-if="formList.length">
        <el-collapse v-model="activeName"
          accordion>
          <el-collapse-item :name="v.ids"
            v-for="v in formList"
            :key="v.ids">
            <template slot="title">
              <p :style="{ color: activeItem.ids == v.ids ? '#28cccb' : '#333' }">
                {{ v.name }}
              </p>
            </template>
            <div>
              {{ v.searchText }}
            </div>
            <el-button-group style="margin-top: 10px">
              <el-button type="primary"
                size="mini"
                @click="activeItem = v">选择模板</el-button>
              <el-button type="primary"
                size="mini"
                @click="editList(v)">编辑</el-button>
              <el-button type="primary"
                size="mini"
                @click="deleteItem(v.ids)">删除</el-button>
            </el-button-group>
          </el-collapse-item>
        </el-collapse>
      </div>
      <el-empty description="暂无数据"
        v-else></el-empty>
    </div>
    <div class="rightWrap commonWrap">
      <FormContent :activeItem="activeItem"
        :showDownload="judgeAuthority('baobiao:reportTemplate:export')" />
    </div>
    <AddFormTemplate v-if="dialogFormVisible"
      :addFormItem="addFormItem"
      @handleRenewFun="handleRenewFun" />
  </div>
</template>

<script>
import { judgeAuthority } from "@/assets/js/utils";
import FormContent from "@/components/baobiaoguanli/FormContent.vue";
import AddFormTemplate from "@/components/baobiaoguanli/AddFormTemplate.vue";
import api from "@/api";
export default {
  components: {
    FormContent,
    AddFormTemplate,
  },
  data() {
    return {
      activeName: "",
      formList: [], //模板列表
      activeItem: {}, //选中模板
      dialogFormVisible: false,
      searchTxt: "",
      addFormItem: {},
    };
  },
  watch: {},
  methods: {
    judgeAuthority,
    deleteItem(id) {
      this.$confirm("此操作将永久删除此模板, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.$store.commit("SET_LOADING", true);
          let res = await api.formDeleteItem({}, id);
          if (res && res.data) {
            setTimeout(() => {
              this.$message.success("删除成功!");
              this.$store.commit("SET_LOADING", false);
              this.getMenuList();
            }, 500);
          }
        })
        .catch(() => {});
    },

    editList(row) {
      this.addFormItem = row;
      this.dialogFormVisible = true;
    },
    handleRenewFun() {
      this.$store.commit("SET_LOADING", true);
      setTimeout(() => {
        this.$store.commit("SET_LOADING", false);
        this.dialogFormVisible = false;
        this.getMenuList();
      }, 500);
    },
    async getMenuList() {
      this.formList = [];
      this.activeItem = {};
      this.activeName = "";
      let res = await api.formGetReportList({
        pageSize: 100000,
        page: 0,
        name: this.searchTxt,
      });
      if (res && res.status == 200) {
        this.formList = res.data.data;
        this.formList.map((v) => {
          v.ids = v.id.id;
        });
        if (this.formList.length > 0) {
          this.activeItem = this.formList[0];
          this.activeName = this.formList[0].ids;
        }
      }
    },
  },

  created() {
    this.getMenuList();
  },
};
</script>

<style lang="scss" scoped>
.reportTemplateWrap {
  @include setFlexBetween;
  .leftMenu {
    width: 21%;
    height: 100%;
    overflow: hidden;
    background: #fff;
    .listUl {
      width: 90%;
      height: 87%;
      margin: 15px auto;
      overflow-y: auto;
    }
  }

  .rightWrap {
    width: calc(79% - 24px);
    height: $innerWidth;
    margin: 12px auto;
    .contentWrap {
      width: 98%;
      height: calc(100% - 20px);
      margin: 10px auto;
      .mouldHeader {
        position: relative;
        p {
          font-size: 16px;
        }
        // }
        .saveBtn {
          position: absolute;
          right: 10px;
          top: 10px;
        }
      }
      .tabWrap {
        width: 100%;
        height: calc(100% - 100px);
        ::v-deep .el-table__fixed {
          height: 100% !important;
        }
      }
    }
  }
}
</style>